import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PalmtreeIcon, WineIcon, HomeIcon, PartyPopperIcon, CarIcon, UsersIcon, TrophyIcon, TicketIcon } from 'lucide-react';
const cases = [{
  icon: PalmtreeIcon,
  title: 'Trips away',
  color: 'bg-blue-50',
  iconBg: 'bg-blue-100',
  iconColor: 'text-blue-600'
}, {
  icon: WineIcon,
  title: 'Group dinners',
  color: 'bg-purple-50',
  iconBg: 'bg-purple-100',
  iconColor: 'text-purple-600'
}, {
  icon: HomeIcon,
  title: 'House shares',
  color: 'bg-green-50',
  iconBg: 'bg-green-100',
  iconColor: 'text-green-600'
}, {
  icon: PartyPopperIcon,
  title: 'Stag & hen weekends',
  color: 'bg-orange-50',
  iconBg: 'bg-orange-100',
  iconColor: 'text-orange-600'
}, {
  icon: TicketIcon,
  title: 'Festivals',
  color: 'bg-pink-50',
  iconBg: 'bg-pink-100',
  iconColor: 'text-pink-600'
}, {
  icon: CarIcon,
  title: 'Taxi shares',
  color: 'bg-yellow-50',
  iconBg: 'bg-yellow-100',
  iconColor: 'text-yellow-600'
}, {
  icon: UsersIcon,
  title: 'Family costs',
  color: 'bg-teal-50',
  iconBg: 'bg-teal-100',
  iconColor: 'text-teal-600'
}, {
  icon: TrophyIcon,
  title: 'Sports teams',
  color: 'bg-indigo-50',
  iconBg: 'bg-indigo-100',
  iconColor: 'text-indigo-600'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4
    }
  }
};
export function UseCases() {
  return <section id="use-cases" className="py-24 lg:py-32 bg-white" data-id="element-296" data-mp="3fj0ahlnvgmyh">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297" data-mp="31rc1hr8x6elq">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-298" data-mp="35tyw1zwz6dmm">
          <p className="text-sm font-semibold text-kitty-yellow-600 uppercase tracking-widest mb-3" data-id="element-299" data-mp="26q4o9alur2r">
            Made for everyday group costs
          </p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-kitty-dark tracking-tight mb-4" data-id="element-300" data-mp="80lls4u45or2">
            Every group moment, covered
          </h2>
          <p className="text-base text-gray-500 max-w-lg mx-auto" data-id="element-301" data-mp="3u6qwqp8i5b2f">
            From weekends away to household costs, KittyPot keeps the maths
            clear so every group can settle with confidence.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 max-w-5xl mx-auto" data-id="element-302" data-mp="3kfvysnlw8n15">
          {cases.map(useCase => <motion.div key={useCase.title} variants={itemVariants} className={`${useCase.color} rounded-2xl p-6 border border-transparent hover:border-gray-200 hover:-translate-y-1 transition-all duration-300 shadow-sm hover:shadow-md flex flex-col items-center text-center`} data-id="element-303" data-mp="36gmvgoisdnel">
              <div className={`${useCase.iconBg} w-12 h-12 rounded-xl flex items-center justify-center mb-4`} data-id="element-304" data-mp="2rg8xpkeearvw">
                <useCase.icon className={`w-6 h-6 ${useCase.iconColor}`} data-id="element-305" data-mp="31c2i1pycvpo8" />
              </div>
              <h3 className={`text-base font-bold text-kitty-dark`} data-id="element-306" data-mp="36b5e4kwcylk2">
                {useCase.title}
              </h3>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}